import { AirportWithVehicleConnectionInput, SortDirectionEnum, Vehicle, VehicleConnection } from '@/models/gen/graphql';
import { QueryInputType, queryInput } from '@/utils';

import { SearchVehiclesTableDocument } from '@/api/queries';
import { VehiclesTypes } from '@/features/Vehicles/types';
import graphApi from '@/api';

const [, runRefetchSearchVehiclesTable] = graphApi(SearchVehiclesTableDocument);

const SEARCH_PAGE_SIZE = 1000;

const buildQuery = (filters: VehiclesTypes.Filters): Record<string, unknown> => {
  const result: Record<string, unknown> = {
    active: queryInput(filters.active !== '' ? [filters.active === '1' ? 1 : 0] : null),
    createdAt: queryInput([], QueryInputType.DEFAULT, SortDirectionEnum.Desc, 0),
  };
  if (filters.airportCode.length > 0) {
    result.airportCode = queryInput(filters.airportCode);
  }
  return result;
};

export const searchVehiclesWithMetadata = async (filters: VehiclesTypes.Filters): Promise<{ vehicles: Vehicle[]; totalCount: number }> => {
  const input: AirportWithVehicleConnectionInput = {
    first: SEARCH_PAGE_SIZE,
    after: null,
    query: [buildQuery(filters)] as any,
  };
  const res = await runRefetchSearchVehiclesTable({ input });
  const connection = res?.searchVehicles?.vehicleWithAirportConnection as VehicleConnection;
  return {
    vehicles: connection?.edges?.map((edge) => edge.node as Vehicle) || [],
    totalCount: connection?.totalCount || 0,
  };
};

export default searchVehiclesWithMetadata;
